module.exports = {
      id: "share-menu-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#share-menu",
      toString: function () {
        return this.url;
      }
    }